/**
 *  @class
 *  @function WhatsAppBtn
 */
if (!customElements.get('whatsapp-btn')) {
	class WhatsAppBtn extends HTMLElement {
		constructor() {
			super();
			this.backTopBtn = document?.querySelector('back-to-top');
		}

		connectedCallback() {
			window.addEventListener('scroll', this.checkVisible.bind(this));
		}

		checkVisible() {
			window.requestAnimationFrame(() => {
				if (this.backTopBtn && this.backTopBtn.classList.contains('back-to-top--active')) {
					this.classList.add('whatsapp-btn--active');
				} else {
					this.classList.remove('whatsapp-btn--active');
				}
			});
		}
	}
	customElements.define('whatsapp-btn', WhatsAppBtn);
}